(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initFormFileInputs = function () {
        var fileInputSelector = '.wpcf7-file-item input[type="file"], input.wpcf7-file[type="file"]';

        if (document.documentElement.dataset.formFileInitialized === 'true') {
            return;
        }

        document.documentElement.dataset.formFileInitialized = 'true';

        function getFileLabel(input) {
            if (!input.files || !input.files.length) {
                return '';
            }

            if (input.files.length === 1) {
                return input.files[0].name;
            }

            return input.files.length + ' pliki';
        }

        function updateTitle(input) {
            var fileItem = input.closest('.wpcf7-file-item') || input.closest('label');
            var title = fileItem ? fileItem.querySelector('.wpcf7-file-item-body-title') : null;

            if (!title) {
                return;
            }

            if (!title.dataset.defaultText) {
                title.dataset.defaultText = title.textContent.trim();
            }

            title.textContent = getFileLabel(input) || title.dataset.defaultText;
        }

        function updateFormTitles(form) {
            var fileInputs = form.querySelectorAll(fileInputSelector);

            fileInputs.forEach(function (input) {
                updateTitle(input);
            });
        }

        document.addEventListener('change', function (event) {
            if (!event.target.matches(fileInputSelector)) {
                return;
            }

            updateTitle(event.target);
        });

        document.addEventListener('wpcf7reset', function (event) {
            window.setTimeout(function () {
                updateFormTitles(event.target);
            }, 0);
        });

        document.addEventListener('wpcf7mailsent', function (event) {
            window.setTimeout(function () {
                updateFormTitles(event.target);
            }, 0);
        });

        document.querySelectorAll('.wpcf7 form, form.wpcf7-form').forEach(function (form) {
            updateFormTitles(form);
        });
    };
})();
